// my-routes.js > PrototypeRoutes
import Dashboard from 'src/pages/coming-soon';
import Kanban from 'src/pages/dashboard/kanban';
import Calendar from 'src/pages/dashboard/calendar';
import DemoList from 'src/wrapper/_basic/demo-list';
import DemoDetail from 'src/wrapper/_basic/demo-detail';

export const prototypeRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.kanban, component: Kanban },
    { path: paths.dashboard.calendar, component: Calendar },
    { path: paths.demo.index, component: DemoList },
    { path: paths.demo.details, component: DemoDetail },
  ];
};
